﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StabilityPoolView = void 0;
const ERC20Contract_1 = require("../../contracts/ERC20Contract");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
const App_1 = require("../../App");
class StabilityPoolView extends com.CmpStabilityPool {
    constructor(contract) {
        super();
        this._contract = contract;
        this.ctrls.btnInfo.onclick = () => new modalCom.DialogOk("Contract address: " + this._contract.address + "<br><br>" + this.ctrls.lFaqInfo.text, "Info").show();
        this.ctrls.btnRefresh.onclick = () => this.refresh();
        this.ctrls.btnUpdate.onclick = () => this.update();
        this.ctrls.btnDepositeLOAN.onclick = () => this.depositeLOAN();
        this.ctrls.btnDepositeUSDL.onclick = () => this.depositeUSDL();
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const needUpdate = yield this._contract.needUpdate();
            if (needUpdate)
                this.ctrls.btnUpdate.enable();
            else
                this.ctrls.btnUpdate.disable();
            this.ctrls.lBalancePLS.text = yield this._contract.getBalance();
            this.ctrls.lBalanceUSDL.text = yield this._contract.getBalanceToken(App_1.App.Inst.chain.addressTokenUSDL);
            this.ctrls.lBalanceLOAN.text = yield this._contract.getBalanceToken(App_1.App.Inst.chain.addressTokenLOAN);
            this.ctrls.lStakedUSDL.text = yield this._contract.getStakedUSDL();
            this.ctrls.lStakedLOAN.text = yield this._contract.getStakedLOAN();
            const stabReward = yield this._contract.getPendingGainForUSDL();
            this.ctrls.lStabilityRewardPLS.text = stabReward.pls;
            this.ctrls.lStabilityRewardLOAN.text = stabReward.loan;
            const stakeReward = yield this._contract.getPendingGainForLOAN();
            this.ctrls.lStakeRewardPLS.text = stakeReward.pls;
            this.ctrls.lStakeRewardUSDL.text = stakeReward.usdl;
            this.ctrls.lPricePLS_ATH.text = yield this._contract.getPricePLS_ATH();
            this.ctrls.lInSwapMode.text = "no";
            if (yield this._contract.getInSwapMode())
                this.ctrls.lInSwapMode.text = "yes";
            this.ctrls.lLastUpdateTime.text = yield this._contract.getLastUpdateTimestamp();
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            yield this._contract.update();
        });
    }
    depositeLOAN() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            const value = parseFloat(this.ctrls.iValueLOAN.value);
            if (!value)
                return;
            var erc20 = new ERC20Contract_1.ERC20Contract(App_1.App.Inst.chain.addressTokenLOAN, App_1.App.Inst.chain.web3);
            erc20.transfer(this._contract.address, value + "");
        });
    }
    depositeUSDL() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            const value = parseFloat(this.ctrls.iValue.value);
            if (!value)
                return;
            var erc20 = new ERC20Contract_1.ERC20Contract(App_1.App.Inst.chain.addressTokenUSDL, App_1.App.Inst.chain.web3);
            erc20.transfer(this._contract.address, value + "");
        });
    }
}
exports.StabilityPoolView = StabilityPoolView;
//# sourceMappingURL=StabilityPoolView.js.map